__turbopack_context__.v({
  "bonus": "bonus-module__23DOvW__bonus",
  "title": "bonus-module__23DOvW__title",
});
